import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from '../queryClient';
import { Props } from './QueryProvider.types';

export default function QueryProvider({ children }: Props) {
   return (
      <QueryClientProvider client={queryClient}>
         {children}
         {process.env.NODE_ENV !== 'production' && <ReactQueryDevtools />}
      </QueryClientProvider>
   );
}
